<template>
  <DToast position="top-left" group="tl" />
  <DToast position="top-center" group="tc" />
  <DToast position="bottom-center" group="bc" />
  <DToast position="top-right" group="tr" />
  <DToast position="bottom-left" group="bl" />
  <DToast position="bottom-right" group="br" />
</template>
<script setup>
import { DToast } from '@disguise/cloud-ui';
</script>
